export * from './src/contacts-v4-contact-contacts.meta.js';
